import React, { useState, useEffect } from "react";
import "./styles/skills.css";
import Skillssevice from "../../service/Skillssevice";

const Skills = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      const response = await Skillssevice.getAllInfo();
      const newData = response.docs.map((doc) => doc.data()); // Extract data from each document
      setData(newData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  return (
    <div className="skills-container">
      <h2 className="skills-title">Skills</h2>
      <div className="skills-list">
        {data.map((skill, index) => (
          <div className="skill" key={index}>
            {skill.skill} {/* Assuming your data has a property called 'skillName' */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Skills;
